<template>
  <div class="m-pc-footer">
    <!-- <div class="g-footer-content">
      ©2023 Sinobase Marketing Technology Corporation. All Rights Reserved
    </div>-->
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped></style>
